import React from 'react'
import MultiSelect from '../kits/MultiSelect'

/**
 * Wybór marek z TWARDYM limitem (backend odrzuca powyżej `max`). MultiSelect
 * z modułu doboru nie zna pojęcia limitu, więc owijamy `onChange`: próba
 * dodania szóstej marki jest po prostu ignorowana, a licznik obok pokazuje,
 * że limit jest pełny — użytkownik widzi WARUNEK, zanim wyśle formularz
 * i dostanie odrzucenie od backendu.
 */
const BrandPicker = ({ options, value, onChange, max = 5, ariaLabel }) => {
  const pelny = value.length >= max

  return (
    <div>
      <MultiSelect
        options={options}
        value={value}
        onChange={(next) => onChange(next.length <= max ? next : value)}
        searchable
        placeholder="wybierz marki"
        ariaLabel={ariaLabel}
      />
      <p className={`mt-1 text-xs ${pelny ? 'text-amber-600' : 'text-gray-400'}`}>
        {value.length} z {max} {pelny && '— limit osiągnięty'}
      </p>
    </div>
  )
}

export default BrandPicker
